<template>
  <div class="time-control">
    <el-table
      :data="controlArr"
      style="width: 100%">
      <el-table-column
        prop="startTime"
        label="开启时间"
         align="center"
       >
        <template slot-scope="scope">
          <el-time-picker
            :clearable="false"
            prefix-icon=""
            format='HH:mm'
            v-model="scope.row.startTime"
            placeholder="选择时间">
          </el-time-picker>
        </template>
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="关闭时间"
        align="center"

       >
        <template slot-scope="scope">
          <el-time-picker
            :clearable="false"
             format='HH:mm'
            v-model="scope.row.endTime"
            placeholder="选择时间">
          </el-time-picker>
        </template>
      </el-table-column>
      <el-table-column
        prop="swiths"
         align="center"
        label="远程控制">
        <template slot-scope="scope">

          <el-checkbox-group v-model="scope.row.swiths">
            <el-checkbox @change="changeBox(item,scope.row)" v-for="(item,index) in swiths" :label="item.iotName" :key="index">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </template>
      </el-table-column>
      <el-table-column
        prop="swithRate"
         align="center"
        label="频率">
        <template slot-scope="scope">
          <el-radio v-if="judgeType" v-model="scope.row.swithRate" label="1">不重复</el-radio>
          <el-radio v-model="scope.row.swithRate" label="2">每天</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        prop="on"
         align="center"
        label="状态">
         <template slot-scope="scope">
           <el-switch
           @change="changeStatus(scope.row)"
            v-model="scope.row.on"
            active-color="#13ce66"
            inactive-color="#f2f2f2">
          </el-switch>

        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" >
        <template slot-scope="scope">
          <span class="content-delete" @click="handleDelete(scope.$index, scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="add-wrap">
      <div @click="add" class="add">
        <img src="../../../public/images/list_add.png" alt="">
        <span>添加</span>
      </div>
    </div>
    <el-row>
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </el-row>
  </div>
</template>

<script>
import equipmentSocketModule from '../../store/modules/equipmentSocket'
import indexModule from '../../store/modules/index'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'TimeControl',
  data () {
    return {
      controlArr: [
        {
          startTime: '',
          endTime: '',
          swiths: [],
          on: true,
          swithRate: ''
        },
        {
          startTime: '',
          endTime: '',
          swiths: [],
          on: true,
          swithRate: ''
        }
      ]

    }
  },
  watch: {
    async equipmentId () {
      if (this.equipmentId) {
        // let controlArr = JSON.parse(JSON.stringify(this.controlArr))
        this.initSwithTimer()
      }
    }
  },
  mounted () {
    if (this.equipmentId) {
      this.initSwithTimer()
    }
  },
  computed: {
    ...mapState(indexModule, ['equipmentId', 'equipmentList']),
    ...mapState(equipmentSocketModule, ['swiths']),
    // 判断类型是不是等于5(沃渔)
    judgeType () {
      if (this.isType5().deviceType !== 5) {
        return true
      } else {
        this.controlArr.forEach((item) => {
          item.swithRate = '2'
        })
        return false
      }
    }
  },
  methods: {
    ...mapActions(equipmentSocketModule, ['swithTimer', 'updateSwithTimer', 'getEquipmentSocket', 'changeSwitchStatus', 'deleteSwithTimer']),
    // 获取列表数据
    async initSwithTimer () {
      this.swithTimer(this.equipmentId).then((data) => {
        let result = data
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            result[i].swithRate = result[i].swithRate.toString()
            result[i].startTime = result[i].startTime
            result[i].endTime = result[i].endTime
            result[i].swiths = result[i].swiths.map(m => m.key)
          // let a = []
          // result[i].swiths.forEach((f) => {
          //   a.push(f.value)
          // })
          // result[i].swiths = a//格式化开关['aa','bb']
          }
          this.controlArr = result
        } else {
          this.controlArr = [
            {
              startTime: '',
              endTime: '',
              swiths: [],
              on: true,
              swithRate: '1'
            },
            {
              startTime: '',
              endTime: '',
              swiths: [],
              on: true,
              swithRate: '1'
            }
          ]
        }
      }).catch((err) => {
        this.$Alert.info({
          content: err.response.data,
          duration: 3000,
          status: 'error'
        })
      })
    },
    // 切换记录状态
    changeStatus (row) {
      if (row.id) {
        this.changeSwitchStatus(row.id).then(() => {
          if (row.on === true) {
            this.$Alert.info({
              content: '开启成功',
              duration: 1000,
              status: 'success'
            })
          } else if (row.on === false) {
            this.$Alert.info({
              content: '关闭成功',
              duration: 1000,
              status: 'success'
            })
          }
        }).catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
        })
      } else {
        if (row.on === true) {
          this.$Alert.info({
            content: '开启成功',
            duration: 1000,
            status: 'success'
          })
        } else if (row.on === false) {
          this.$Alert.info({
            content: '关闭成功',
            duration: 1000,
            status: 'success'
          })
        }
      }
    },
    handleChecked (index, row) {
      if (row.swiths.length > 0) {
        row.swiths = row.swiths.toString()
      }
    },
    isType5 () {
      try {
        let iot = this.equipmentList.find((item) => {
          return item.id === this.equipmentId
        })
        if (iot) {
          if (iot) { return iot }
        } else {
          return {}
        }
      } catch (err) {
        console.log('me')
      }
    },
    // 切换多选框 渔控仪 开关限制
    changeBox (obj, data) {
      console.log(this.equipmentId)
      let iot = this.isType5()
      if (iot.deviceType !== 5) {
        return
      }
      let arr = []
      this.controlArr.forEach((item) => {
        item.swiths.forEach((m, index) => {
          arr.push(m)
        })
      })
      let num = 0
      arr.forEach((k) => {
        if (k === obj.iotName) {
          console.log(num)
          num++
        }
      })
      if (num > 2) {
        // if (data.swiths.indexOf(obj.iotName)) {
        data.swiths.pop()
        // }
        this.$Alert.info({
          content: '同一开关最多只能开启两个!',
          duration: 3000,
          status: 'error'
        })
      }
    },
    async formateTime (time) {
      var timestamp = new Date(Date.parse(time))
      let minutes = this.doubleNumber(timestamp.getMinutes())
      let hours = this.doubleNumber(timestamp.getHours())
      return hours + ':' + minutes
    },
    doubleNumber (number) {
      number = number.toString()
      if (number.length === 1) {
        return '0' + number
      } else {
        return number
      }
    },
    // 删除
    handleDelete (index, row) {
      console.log(row)
      if (row.id) {
        this.$confirm('您确定删除当前选中的记录吗？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning'
          showClose: false
        }).then(async () => {
          this.deleteSwithTimer(row.id).then(() => {
            this.$Alert.info({
              content: '删除成功',
              duration: 1000,
              status: 'success'
            })
            this.$Alert.info({
              content: '最小值不能大于最大值',
              duration: 3000,
              status: 'error'
            })
            this.initSwithTimer(index)
          }).catch((err) => {
            this.$Alert.info({
              content: err.response.data,
              duration: 3000,
              status: 'error'
            })
          })
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$confirm('您确定删除当前选中的记录吗？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false
        }).then(async () => {
          // this.initSwithTimer(index)
          this.controlArr.splice(index, 1)
          this.$Alert.info({
            content: '删除成功',
            duration: 1000,
            status: 'success'
          })
        }).catch(err => {
          console.log(err)
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
        })
      }
    },
    add () {
      var obj = {
        endTime: '',
        on: true,
        startTime: '',
        swithRate: '1',
        swiths: []
      }
      this.controlArr.push(obj)
    },
    // 保存
    async save () {
      // this.controlArr.startTime =  this.controlArr.startTime
      let saveArr = JSON.parse(JSON.stringify(this.controlArr))
      for (let i = 0; i < saveArr.length; i++) {
        saveArr[i].startTime = await this.formateTime(saveArr[i].startTime)
        saveArr[i].endTime = await this.formateTime(saveArr[i].endTime)
        if (saveArr[i].startTime === '') {
          this.$Alert.info({
            content: '请选择开始时间',
            duration: 3000,
            status: 'error'
          })
          return
        } else if (saveArr[i].endTime === '') {
          this.$Alert.info({
            content: '请选择结束时间',
            duration: 3000,
            status: 'error'
          })
          return
        } else if (saveArr[i].swiths.length === 0) {
          this.$Alert.info({
            content: '请至少选择一个开关',
            duration: 3000,
            status: 'error'
          })
          return
        } else {
          saveArr[i].swiths = saveArr[i].swiths.toString()
          // let arrvalue = []// 用于存放取出的数组的值
          // for (let j = 0; j < saveArr[i].swiths.length; j++) {
          //   arrvalue.push(j)// 数组的索引是从0开始的
          // }
          // saveArr[i].swiths = arrvalue.toString()
        }
      }

      this.updateSwithTimer({
        id: this.equipmentId,
        saveArr: saveArr
      })
        .then(async () => {
          this.$Alert.info({
            content: '保存成功',
            duration: 1000,
            status: 'success'
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancel () {
      this.initSwithTimer().then(() => {
      })
    }
  }
}
</script>

<style lang="scss">
.time-control{
  .el-input{

    .el-input__icon {
      // position: absolute;
      // left:120px;
      height: 100%;
      width: 25px;
      line-height: 40px;
      font-size: 22px;
    }
  }

}

//删除框样式
.el-message-box{
  width:340px;
  height:180px;
  background:rgba(32,48,81,1);
  border:1px solid #2886F2;
  .el-message-box__content{
    .el-message-box__message{
      font-size:16px;
      text-align:center;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(187,212,233,1);
      margin-top:-10px;
      padding-bottom:20px;
    }
  }
  .el-message-box__btns{
    .el-button--default:first-child{
      width:120px;
      height:40px;
      background:rgba(30,63,117,0);
      border-radius:4px;
    }
    .el-button--primary:last-child{
      width:120px;
      height:40px;
      background:rgba(255,47,47,1);
      border-radius:4px;
      border:1px solid rgba(255,47,47,1);
    }
  }
}
.el-radio__label {
  color: #BBD4E9;
}
.el-radio__inner {
  border: 1px solid #409EFF;
  background:none;
}
.el-checkbox__label {
    color: #BBD4E9;
}
.el-checkbox__inner{
  border: 1px solid #409EFF;
  background:none;
}
.el-icon-time:before {
    content: "\E642";
    color: #07f;
}
.time-control {
  .el-checkbox-group{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    // padding: 0 15px;
  }
  .el-checkbox{
    margin-left: 5px;
  }
  .el-checkbox + .el-checkbox {
    margin-left:5px;
  }
}
</style>

<style lang="stylus" scoped>
.add-wrap {
  background: rgba(175, 201, 255, 0.1);
}

.add {
  display: inline-block;
  margin-left: 30px;
  line-height: 50px;
  cursor: pointer;

  img {
    width:20px;
    height:20px;
    vertical-align: -5px;
    margin-right: 5px;
  }
  span{
    font-size:14px;
    color:#BBD4E9;
  }
}

.el-row {
  margin-top: 20px;
  margin-left: 0;

  .el-button--default {
    background: none !important;
  }
}

.time-control {
  margin-bottom: 20px;
  .el-date-editor.el-input{
    width:auto;
  }
  .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    // width: 220px;

    .el-input__inner {
      border: 1px solid #07f;
      color: #BBD4E9;
      background: #1E3F75;
    }
  }

  .el-input__prefix {
    left: 190px;
  }

  .el-icon-time:before {
    color: #07f;
  }
}
</style>

<style>
.el-table {
  color: white;
  background: rgba(175,201,255,0.1)!important;
}
.el-input--prefix .el-input__inner {
  padding-left: 38px;
  background: none !important;
  border: 1px solid #07f;
  color: white;
}
</style>
